import createSagaMiddleware from "redux-saga";
import { configureStore } from "@reduxjs/toolkit";

import { RootSaga } from "./Sagas";
import { rootReducer } from "./Reducers";

const sagaMiddleware = createSagaMiddleware();

export const Store = configureStore({
  reducer: rootReducer,
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(sagaMiddleware)
});

sagaMiddleware.run(RootSaga);
